import { Circle, Gift } from 'react-feather'

export default [
	{
		id: 'event',
		title: 'Sự kiện',
		icon: <Gift size={20} />,
		children: [
			{
				id: 'giftcode',
				title: 'GiftCode',
				icon: <Circle size={12} />,
				navLink: '/event/giftcode/'
			},
			{
				id: 'event-get',
				title: 'Nhận giải thưởng',
				icon: <Circle size={12} />,
				navLink: '/event/award'
			},
			{
				id: 'event-charge',
				title: 'Quà nạp',
				icon: <Circle size={12} />,
				navLink: '/event/charge'
			},
			{
				id: 'event-top',
				title: 'Đua TOP',
				icon: <Circle size={12} />,
				navLink: '/event/top'
			},
			{
				id: 'event-goblin',
				title: 'Truyền nhân Goblin',
				icon: <Circle size={12} />,
				navLink: '/event/goblin'
			}
		]
	}
]
